var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['l-type', _vm.active ? 'active' : '', _vm.type]},[_c('div',{staticClass:"num",style:({backgroundColor: _vm.mainColor})},[_vm._v(_vm._s(_vm.amount))]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }